import React from "react";
import { Link, useLocation } from "react-router-dom";
import allProducts from "../data/searchproduct";
import { getProductLink } from "../utils/productRoutes";
import "./searchResult.css";

const SearchResults = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search).get("q") || "";
  const lowerQuery = query.trim().toLowerCase();

  const results = allProducts.filter((p) => {
    const id = String(p.id).toLowerCase();
    const name = String(p.name).toLowerCase();

    return id.includes(lowerQuery) || name.includes(lowerQuery);
  });

  return (
    <div className="search-page">
      {results.length > 0 ? (
        <div className="search-grid">
          {results.map((item) => (
            <Link to={getProductLink(item)} key={item.id} className="search-card">
              <div className="search-img">
                <img src={item.image} alt={item.name} />
              </div>

              <div className="search-content">
                <span className="search-name">{item.name}</span>
                <span className="search-code">Product Code: {item.id}</span>
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <p className="no-result">No results found</p>
      )}
    </div>
  );
};

export default SearchResults;
